import { useContext } from "react";
import MarkingClassesContext from "./MarkingClassesContext";

const useMarkingClasses = () => {
  const context = useContext(MarkingClassesContext);
  if (context === undefined) {
    throw new Error(
      "useMarkingClasses must be used within a MarkingClassesContext"
    );
  }
  return context;
}

export default useMarkingClasses

